import {Injectable, EventEmitter } from "@angular/core";    

@Injectable()
export class DataService {

    tradeboards: any = [];
    existing_tbs: any = [];
    tradeboard: any = {
        edit_mode: false,
        _id: "0",
        name: 'No Name',
        params: {
            product_type: null,
            lot_size: 0,
            min_lot_size: 0,
            max_lot_size: 0,
            quantity: 0,
            symbol: null
        },
        users: [],
        contracts: []
    };
    categories: any = [];
    segments: any = [];
    strategies: any = [];
    live_socket_details: any;

    onTradeboardOpened: EventEmitter<any> = new EventEmitter();
    onPageLoaded: EventEmitter<any> = new EventEmitter();
    onStrategyDetailsOpening: EventEmitter<any> = new EventEmitter();
    onStrategyDetailsPopulating: EventEmitter<any> = new EventEmitter();
    onSaveSettings: EventEmitter<any> = new EventEmitter();
    onStrategyDetailsSaved: EventEmitter<any> = new EventEmitter();
    onStrategyChanged: EventEmitter<any> = new EventEmitter();
    onRetrieveHeaderPriceUpdates: EventEmitter<any> = new EventEmitter();

    saveLiveSocketDetails(details: any) {
        this.live_socket_details = details;
        this.live_socket_details.tokens = [];
        this.live_socket_details.token_map = {};
        Object.keys(details.instruments).forEach((key) => {
            this.live_socket_details.tokens.push(details.instruments[key]);
        });
        Object.keys(details.instruments).forEach((key) => {
            this.live_socket_details.token_map[`${details.instruments[key]}`] = key;
        });
        this.live_socket_details
    }

    retrieveLiveSocketDetails() {
        return this.live_socket_details;
    }

    strategyDetailsOpening(data: any) {
        this.onStrategyDetailsOpening.emit(data);
    }

    strategyChanging(data: any) {
        this.onStrategyChanged.emit(data);
    }

    strategyDetailsPopulating(data: any) {
        this.onStrategyDetailsPopulating.emit(data);
    }

    saveSettings(data: any) {
        this.onSaveSettings.emit(data);
    }

    strategyDetailsSaved(data: any) {
        this.onStrategyDetailsSaved.emit(data);
    }

    pageLoaded(data: any) {
        this.onPageLoaded.emit(data);
    }

    tradeboardOpened(data: any) {
        this.tradeboardAdded(data);
        this.onTradeboardOpened.emit(this.tradeboards);
    }

    tradeboardUpdated(data: any) {
        if (data) {
            let tidx = this.findIndex(data);
            if (tidx > -1) {
                this.tradeboards[tidx] = data;
            }
        }
    }

    tradeboardAdded(data: any) {
        if (data) {
            let data_id = `${data.name}_${data._id}`;
            let idx = this.existing_tbs.indexOf(data_id);
            if (idx == -1) {
                this.tradeboards.push(data);
                this.existing_tbs.push(data_id);
            } else {
                this.tradeboards[idx] = data;
            }
        }
    }

    removeTradeboard(data: any) {
        if (data) {
            let data_id = `${data.name}_${data._id}`;
            let idx = this.existing_tbs.indexOf(data_id);
            if (idx > -1) {
                let tidx = this.findIndex(data);
                if (tidx > -1) {
                    this.tradeboards.splice(tidx, 1);
                }
                this.existing_tbs.splice(idx, 1);
            }
        }
    }

    clearTmpTradeboard() {
        let tb = this.findTmpTradeboard();
        this.removeTradeboard(tb);
    }

    addTmpTradeboard() {
        let data = JSON.parse(JSON.stringify(this.tradeboard)); 
        this.tradeboardAdded(data);
        this.onTradeboardOpened.emit(this.tradeboards);
        return data;
    }

    findTmpTradeboard() {
        let tradeboard = null;
        for (let idx = 0; idx < this.tradeboards.length; idx++) {
            if (this.tradeboards[idx]._id == "0") {
                tradeboard = this.tradeboards[idx];
                break;
            }
        }
        return tradeboard;
    }

    findIndex(tradeboard: any) {
        let tidx = -1;
        for (let idx = 0; idx < this.tradeboards.length; idx++) {
            if (this.tradeboards[idx].name == tradeboard.name) {
                tidx = idx;
                break;
            }
        }
        return tidx;
    }

    getTradeboardAt(idx: any) {
        if (this.tradeboards.length > 0) {
            if (idx <= (this.tradeboards.length -1)) {
                return this.tradeboards[idx];
            }
        }
        return null;
    }

    getCategories() { return this.categories; }
    getSegments() { return this.segments; }
    getStrategies() { return this.strategies; }

    setCategories(categories: any) { this.categories = categories;  }
    setSegments(segments: any) { this.segments = segments;  }
    setStrategies(strategies: any) { this.strategies = strategies;  }
}